import React from "react";
import ListPopup from "./ListPopup";
import TryAgain from "./TryAgain";
import CancelAppointment from "./CancelAppointment";

const dialogTypes = {
  listpopup: ListPopup,
  tryagain: TryAgain,
  cancelappointment: CancelAppointment,
};

const getDialogs = (dialogType) => dialogTypes[dialogType];

const Dialog = (props) => {
  const DialogComponent = getDialogs(props.dialogType);
  return <DialogComponent {...props} />;
};

export default Dialog;
